import { useEffect, useState } from 'react';
import { analytics, api, useUser } from 'libs';
import { Select } from 'components/common';
import Filter from './Filter';

interface LenderRow {
  id: number;
  name: string;
  is_pro_only?: boolean;
}

interface LenderFilterProps {
  defaultMenuIsOpen?: boolean;
  disabled: boolean;
  filters: { lenders?: (number | string)[] };
  isPro?: boolean;
  onFilter: (update: { lenders: (number | string)[] | null }) => void;
}

export const LenderFilter = ({
  defaultMenuIsOpen = false,
  disabled,
  filters,
  isPro = false,
  onFilter,
}: LenderFilterProps) => {
  const user = useUser();
  const [lenders, setLenders] = useState<LenderRow[]>([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get('lenders', { params: { sort: 'name' } });
      setLenders(data);
    })();
  }, []);

  const onChange = (
    options: { label: string; value: number }[] | null,
    action: string,
    option?: { label: string; value: number }
  ) => {
    if (action === 'clear') analytics.productSearch.filter({ lenders: 'cleared' });
    if (action === 'select-option') {
      analytics.productSearch.filter({ lenders: option?.label });
    }
    if (action === 'remove-value' || action === 'pop-value') {
      analytics.productSearch.filter({ lenders: options?.map((opt) => opt.label).join(', ') || 'cleared' });
    }
    const filter = { lenders: options?.map((opt) => opt.value) || null };
    onFilter(filter);
  };

  const getOptions = () => {
    const filteredLenders = user.features.is_pro ? lenders : lenders.filter((lender) => !lender.is_pro_only);

    const options = filteredLenders.map((lender) => ({
      label: lender.name,
      value: lender.id,
    }));

    return options;
  };

  const getSelectedOptions = () => {
    const options = getOptions();
    const lenderId = filters.lenders?.map((id) => parseInt(String(id), 10));

    return lenderId ? options.filter((option) => lenderId.includes(option.value)) : null;
  };

  return (
    <Filter name="Lenders" isPro={isPro}>
      <Select
        testId="filter-lenders"
        className="form-react-select"
        clearValue={null}
        defaultMenuIsOpen={defaultMenuIsOpen}
        disabled={disabled || isPro}
        isMulti
        onChange={onChange}
        options={getOptions()}
        placeholder="All"
        selected={getSelectedOptions()}
      />
    </Filter>
  );
};

export default LenderFilter;
